import { isCampaignClientContestType } from './CampaignType'
import { NameDto } from './NameDto'
import { CurrencyType } from './WalletDto'

export interface ClientRebateCampaignDto {
  id: string
  name: string | null
  from: string
  to: string
  currency: NameDto<CurrencyType>
  status: NameDto
  account: string | null
  type: NameDto
  disqualified: boolean
  calculationType: NameDto
  internalOnly: boolean
}

export const isCampaignClientContest = (
  campaign?: ClientRebateCampaignDto | undefined
): campaign is ClientRebateCampaignDto => {
  return isCampaignClientContestType(campaign?.type?.id)
}
